import {Component, ErrorHandler, HostListener, Inject, OnInit} from '@angular/core';
import {AuthService, CacheService, ResourceCache, WsDaoEventEntityType} from '@lifeislife/lifeislife-domain';
import {DOCUMENT} from '@angular/common';
import {AppHomeScreenInstallerService, PrimengTranslationService} from '@lifeislife/lifeislife-components';
import {OAuthService} from 'angular-oauth2-oidc';
import {debounceTime, filter, switchMap, take} from 'rxjs/operators';


@Component({
  selector: 'cf-root',
  template: '<router-outlet></router-outlet>',
  providers: [PrimengTranslationService],
})
export class AppComponent implements OnInit {

  constructor(
    private cacheService: CacheService, // service worker cache
    private resourceCacheService: ResourceCache, // application cache (in memory)
    @Inject(DOCUMENT)
    private document: Document,
    private appInstallService: AppHomeScreenInstallerService,
    private oAuthService: OAuthService,
    private authService: AuthService,
    private errorService: ErrorHandler,
    private primengTranslationService: PrimengTranslationService,
  ) {
  }

  ngOnInit(): void {
    this.primengTranslationService.setFrenchTranslation();

    this.cacheService.getUpdateAvailableObservable()
      .subscribe(() => this.onUpdateAvailable());
    // Check new version every min
    this.cacheService.startPollingUpdates();

    // Skip cache for some resource types, so that clicking on header actually refresh data
    this.resourceCacheService.skip(WsDaoEventEntityType.SUBSCRIPTION);
    this.resourceCacheService.skip(WsDaoEventEntityType.INSURANCE_SUBSCRIPTION);

    // Use the silent refresh iframe to refresh oidc tokens
    this.oAuthService.setupAutomaticSilentRefresh({}, 'access_token');
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    this.appInstallService.onBeforeInstallPromt(event);
  }

  @HostListener('window:appInstalled', ['$event'])
  onAppInstalled(event: Event) {
    this.appInstallService.onAppInstalled(event);
  }

  private onUpdateAvailable() {
    this.authService.getState$().pipe(
      // wait for settled state
      debounceTime(200),
      filter(state => state.status === 'authenticating'),
      take(1),
      switchMap(() => this.cacheService.activateUpdate()),
    ).subscribe({
        next: e => {
          if (e) {
            this.onNewVersionActivated();
          }
        },
        error: e => {
          this.errorService.handleError(e);
          if (this.document) {
            this.document.location.reload();
          }
        },
      });
  }

  private onNewVersionActivated() {
    if (this.document) {
      this.document.location.reload();
    }
  }

}
